export default "__VITE_ASSET__62de6877__"